module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    attrs: {
      "id": "zezhao"
    }
  }, [_c('div', {
    staticClass: "tu"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.list,
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.get))])]), _vm._v(" "), _c('div', {
    staticClass: "details",
    staticStyle: {
      "margin-top": "-6px",
      "padding-top": "20px",
      "padding-bottom": "20px"
    }
  }, [_c('p', {
    staticClass: "biao"
  }, [_c('span', {
    staticClass: "setpan"
  }, [_vm._v(_vm._s(_vm.xiang)), _c('p', [_vm._v(_vm._s(_vm.outtime))])])])]), _vm._v(" "), _c('div', {
    staticClass: "remove"
  }, [_c('img', {
    attrs: {
      "src": require("../img/up1.png"),
      "alt": ""
    },
    on: {
      "click": _vm.show
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d491c5a"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/xstom.vue
// module id = 255
// module chunks = 0